import {styled} from '@linaria/react';
import React, {FC, JSX} from 'react';
import {COLORS} from '../../../constants/colors';
import {
  desktopAndUpLinaria,
  largeScreensLinaria,
} from '../../../constants/customMedia';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import {useInView} from '../../../hooks/useInView/useInView';
import {Icon} from '../../atoms/Icon/Icon';
import {GenericIconName} from '../../atoms/Icon/IconName';

export const ProductTileEndOfStream: FC<{
  endOfStreamDescription: string;
  Comp?: keyof JSX.IntrinsicElements;
  gridColumns?: number;
}> = ({gridColumns = 2, endOfStreamDescription, Comp = 'li'}) => {
  const {ref, inView} = useInView<HTMLLIElement>({
    threshold: 1,
    triggerOnce: true,
  });

  return (
    <ProductTileEndOfStreamWrapper
      $gridColumns={gridColumns}
      ref={ref}
      as={Comp}
    >
      <IconAnimationWrapper $shouldAnimate={inView}>
        <AnimatedIcon
          $shouldAnimate={inView}
          asset={GenericIconName.AlertSuccess}
          size="L"
        />
      </IconAnimationWrapper>
      <AnimatedDescription $shouldAnimate={inView}>
        {endOfStreamDescription}
      </AnimatedDescription>
    </ProductTileEndOfStreamWrapper>
  );
};

const ProductTileEndOfStreamWrapper = styled.li<{
  $gridColumns: number;
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1.5rem 3rem 1rem;

  // ensure it spans the entire grid columns.
  grid-column: span ${({$gridColumns}) => $gridColumns};
  ${desktopAndUpLinaria(`grid-column: span 3;`)}
  ${largeScreensLinaria(`grid-column: span 4;`)}
`;

const IconAnimationWrapper = styled.div<{$shouldAnimate: boolean}>`
  position: relative;
  &:after {
    content: '';
    position: absolute;
    transform: translateX(
        ${({$shouldAnimate}) => ($shouldAnimate ? '1rem' : '0.5rem')}
      )
      scale(${({$shouldAnimate}) => ($shouldAnimate ? '0' : '1')});
    top: 0.5rem;
    background-color: ${COLORS.White};
    transition: transform 0.3s;
    transition-delay: 0.3s;
  }
`;

const AnimatedIcon = styled(Icon)<{$shouldAnimate: boolean}>`
  position: relative;
  opacity: ${({$shouldAnimate}) => ($shouldAnimate ? '1' : '0')};
  transform: scale(${({$shouldAnimate}) => ($shouldAnimate ? '1' : '0')});
  transition: opacity, transform 0.3s;
`;

const AnimatedDescription = styled.p<{$shouldAnimate: boolean}>`
  position: relative;
  color: ${COLORS.Black};
  margin-top: 0.75rem;
  top: 0.3125rem;
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.bold};
  text-align: center;
  min-height: 1.875rem;
  width: 100%;
  opacity: ${({$shouldAnimate}) => ($shouldAnimate ? '1' : '0')};
  transform: translateY(
    ${({$shouldAnimate}) => ($shouldAnimate ? '0' : '0.3125rem')}
  );
  transition: opacity, transform 0.3s;
`;
